export default class FullscreenComponent {
    constructor() {
        FullscreenComponent.height()
        window.addEventListener('resize', () => {
            FullscreenComponent.height()
        })
        window.addEventListener('orientationchange', () => {
            FullscreenComponent.height()
        })
    }

    static height() {
        if (window.matchMedia('(max-width: 1000px)').matches) {
            const viewportHeight = window.innerHeight
            const headerHeight = $('[data-element="navbar"]').innerHeight()
            const bottomBarHeight = $('[data-element="wpet-bottom-bar"]').innerHeight()
            const element = $('.alignheight')
            let elementHeight = viewportHeight - headerHeight

            if (typeof bottomBarHeight !== 'undefined') {
                elementHeight = elementHeight - bottomBarHeight
            }

            element.css('height', `${elementHeight}px`)
        }
    }
}
